var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.4 140.2V479C441.4 497.2 426.6 512 408.4 512H103.6C85.3996 512 70.5996 497.2 70.5996 479V33C70.5996 14.8 85.3996 0 103.6 0H301.2L441.4 140.2Z",
    fill: "#518FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.199 257.1H350.799V278.2H161.199V257.1ZM161.199 304.1H350.799V325.2H161.199V304.1ZM161.199 351.2H350.799V372.3H161.199V351.2ZM161.199 398.2H296.099V419.3H161.199V398.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.3 134.9L441.4 233V140.8L372.8 101L320.3 134.9Z",
    fill: "black",
    fillOpacity: 0.0980392
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M441.399 140.2H334.199C315.999 140.2 301.199 125.4 301.199 107.2V0L441.399 140.2Z",
    fill: "#A6C5FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.5852c00c81607228fe4a024553066891.svg";
export { ForwardRef as ReactComponent };